import axios from "axios"
import { env } from '../constants'

/* DASHBOARD ROUTE */
export const dashboard = () => {
    const uri = `${env.startpoint}dashboard`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(data => data.response)
}

/* View ROUTE */
export const view = data => {
    const uri = `${env.startpoint}dashboard/view`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}

/* Video ROUTE */
export const video = data => {
    const uri = `${env.startpoint}dashboard/video`
    const token = localStorage.getItem("token")
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(data => data.response)
}